export default {
  name: {
    id: 'rm_metal_silver_name',
    defaultMessage: 'Silver',
  },
  smartphoneLabel: {
    id: 'rm_metal_silver_smartphone_label',
    defaultMessage: 'Low (about a grain of rice)',
  },
  whatItDoesText: {
    id: 'rm_metal_silver_what_it_does',
    defaultMessage:
      "Silver is the best conductor of electricity of any metal, so it carries current through the tiny contacts and switches on a phone's circuit board. It is also one of the ingredients in the lead-free solder that now joins components together, in place of the older tin and lead mix.",
  },
  extractionText1: {
    id: 'rm_metal_silver_extraction_p1',
    defaultMessage:
      'Almost no silver is mined for its own sake. About 71% of it comes out of the ground as a by-product, while mining companies are really after lead, zinc, copper or gold; only around 29% comes from ores mined mainly for silver. The rock is either dug out by conventional mining or dissolved underground and pumped back up, then crushed, concentrated, dried and refined at high heat.',
  },
  quickFactText: {
    id: 'rm_metal_silver_quick_fact',
    defaultMessage:
      'For five years, the world has used silver faster than mines and recyclers have supplied it. Existing stockpiles have filled the gap, but they cannot be drawn down forever.',
  },
  envSummaryText: {
    id: 'rm_metal_silver_env_summary',
    defaultMessage:
      'Silver’s environmental impact is mainly associated with pollution. In laboratory experiments, it is one of the most toxic metals to aquatic life. Small-scale miners, including silver miners, also use large quantities of mercury, causing severe environmental damage.',
  },
  envWaterText: {
    id: 'rm_metal_silver_env_water_text',
    defaultMessage:
      'Silver is among the metals found to be most toxic to aquatic life in rivers and lakes in laboratory studies, particularly in forms such as silver nitrate and silver iodide. Any leak from a mine or refinery into rivers or groundwater could therefore pose a serious threat. Artisanal and small-scale mining can also introduce additional mercury pollution.',
  },
  envSoilText: {
    id: 'rm_metal_silver_env_soil_text',
    defaultMessage:
      'Small-scale silver mining can release mercury and other polluting chemicals into surrounding soils and sediments. Mercury can persist in the environment and build up in food chains, exposing people and wildlife to long-term harm.',
  },
  envBiodiversityText: {
    id: 'rm_metal_silver_env_biodiversity_text',
    defaultMessage:
      'Because silver compounds are so toxic to water organisms, pollution from mining and refining can damage the plants and animals living in the rivers and wetlands downstream from a mine.',
  },
  humanSummaryText: {
    id: 'rm_metal_silver_human_summary',
    defaultMessage:
      'Most of the human cost of silver is tied to how it is dug. Where it is recovered by hand in small mines, the mercury used to capture it can expose workers and nearby families to a metal that harms the brain and nervous system. Silver mining, and mining in general, can be related to several social and ethical issues, including but not limited to labour exploitation, lack of safety in the working environment, child labour, land conflict',
  },
  geoSummaryText: {
    id: 'rm_metal_silver_geo_summary',
    defaultMessage:
      "Silver's supply carries low political risk. It is mined across many countries rather than controlled by a few, and the real weak spot is not politics but the fact that silver mostly appears as a by-product of other metals.",
  },
  geoDugText: {
    id: 'rm_metal_silver_geo_dug_text',
    defaultMessage:
      'There is no mining concentration. Mexico leads at about 25%, then China near 13% and Peru near 12%, with the rest spread across many countries.',
  },
  geoProcessedText: {
    id: 'rm_metal_silver_geo_processed_text',
    defaultMessage:
      'Silver refining is distributed across many countries, with Japan and China among the major producers of refined silver and several European refineries also active.',
  },
  geoLeverageText: {
    id: 'rm_metal_silver_geo_leverage_text',
    defaultMessage:
      'Silver is not currently used as a political weapon. Some countries impose limited trade measures, such as export-licensing requirements in Mexico, China and Russia, and an export tax in Bolivia. However, none of these measures turns silver into a strategic chokepoint.',
  },
  supplySummaryText: {
    id: 'rm_metal_silver_supply_summary',
    defaultMessage:
      'Silver is already in a structural supply deficit. In 2024, global demand reached 1.16 billion troy ounces, while mine production reached around 820 million ounces and recycling supplied a further 194 million ounces. Supply cannot respond quickly because most silver is recovered as a by-product of lead, zinc, copper and gold mining.',
  },
  supplyReservesText: {
    id: 'rm_metal_silver_supply_reserves_text',
    defaultMessage:
      'Known reserves are about 640,000 tonnes for roughly 25,000 tonnes mined each year. At expected consumption, those reserves may be exhausted around 2036, about 13 years away.',
  },
  supplyDemandText: {
    id: 'rm_metal_silver_supply_demand_text',
    defaultMessage:
      'The market tightness is driven by the fast-growing use of silver in solar panels, combined with supply that cannot expand quickly, so the shortfall is expected to continue in the near term. However, over the long term, demand for silver from solar PV is projected to decrease by approximately 68% between 2025 and 2050.',
  },
  recyclingSummaryText: {
    id: 'rm_metal_silver_recycling_summary',
    defaultMessage:
      'Recyclable in principle, but often lost because of poor collection. Silver is recovered at industrial scale in Europe from old circuit boards and solder, mainly from laptops, tablets and phones, by specialist refiners. The main problem is collection: only about a quarter of e-waste worldwide reaches formal recycling facilities, so most of the silver in discarded devices never enters the recycling system. In 2022, the metals contained in e-waste were worth around $90 billion, but only about $28 billion worth was recovered.',
  },
  mine0Region: {
    id: 'rm_metal_silver_mine0_region',
    defaultMessage: 'Fresnillo',
  },
  mine1Region: {
    id: 'rm_metal_silver_mine1_region',
    defaultMessage: 'Peñasquito',
  },
  mine2Region: {
    id: 'rm_metal_silver_mine2_region',
    defaultMessage: 'Antamina',
  },
  mine3Region: {
    id: 'rm_metal_silver_mine3_region',
    defaultMessage: 'Cerro Rico/Potosí',
  },
  mine4Region: {
    id: 'rm_metal_silver_mine4_region',
    defaultMessage: 'Cannington',
  },
} as const
